/** These codes are emitted only when access authentication rejects before a handler runs. */
export const ACCESS_TOKEN_REJECTION = {
  missing: "AUTH_ACCESS_TOKEN_MISSING",
  expired: "AUTH_ACCESS_TOKEN_EXPIRED",
  invalid: "AUTH_ACCESS_TOKEN_INVALID",
} as const;

const rejectionCodes: readonly string[] = Object.values(ACCESS_TOKEN_REJECTION);

export function isAccessTokenRejection(body: unknown): boolean {
  if (typeof body !== "object" || body === null || !("code" in body)) return false;
  return typeof body.code === "string" && rejectionCodes.includes(body.code);
}
